<template>
  <FriedModal @close="cancel">
    <template #header>
      <FriedModalHeader :header="headerText" />
    </template>
    <FriedInput
      v-model="initialsInput"
      v-autofocus
      class="input"
      :error-message="initialsValidation"
      data-external="intitials-input"
      :label="$t('initials')"
      @keydown.enter="submit"
    />
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          data-external="intitials-cancel-input"
          :button-type="ButtonType.Secondary"
          @click="cancel"
        >
          {{ $t('cancel') }}
        </FriedButton>
        <FriedButton data-external="intitials-submit-input" @click="submit">
          {{ $t('add') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import { initialHelper } from '@getaccept/lib-shared-new/src/helpers';
import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { SigningHelper } from '../../helpers/signing.helper';

export default defineComponent({
  props: {
    fullName: {
      type: String,
      default: '',
    },
    initials: {
      type: String,
      default: '',
    },
  },
  emits: ['submit', 'cancel'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const initialsInput = ref('');
    const initialsValidation = ref('');

    const watchInitials = () => {
      initialsValidation.value = '';
    };
    watch(() => props.initials, watchInitials);

    const submit = () => {
      initialsValidation.value = SigningHelper.validateInitials(initialsInput.value);

      if (!initialsValidation.value) {
        emit('submit', initialsInput.value.toUpperCase());
      }
    };

    const cancel = () => {
      emit('cancel');
    };

    onMounted(() => {
      initialsInput.value = props.initials || initialHelper(props.fullName);
    });

    const headerText = computed((): string => {
      if (props.initials) {
        return t('edit-initials').toString();
      }
      return t('add-initials').toString();
    });

    return {
      ButtonType,
      initialsInput,
      initialsValidation,
      watchInitials,
      submit,
      cancel,
      headerText,
    };
  },
});
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
}
</style>
